$(() => {
  // risk assessment master_activities form
  if ($('[data-element-name="risk-assessment-form"]').length) {
    const $form = $('[data-element-name="risk-assessment-form"]').find('form');
    const $submitButton = $('.submit-form');
    const originalLabel = $submitButton.text();

    const $processingModal = $('#attachment-processing-modal');

    function submitForm() {
      $form.submit();
    }

    function handleProcessingFailure() {
      $processingModal.modal('hide');
      $submitButton.prop('disabled', false).text(originalLabel);
    }

    // fix for IE, submit is outside form
    $submitButton.click((_event) => {
      const attachmentIdsToCheck = $form
        .find('input[name="attachment_hashids[]"]')
        .map((_, el) => el.value)
        .get()
        .filter(Boolean);

      if (!attachmentIdsToCheck.length) {
        submitForm();
        return;
      }

      $submitButton
        .prop('disabled', true)
        .text($submitButton.data('processingLabel'));

      const statusUrl = `/attachments/bulk_processing_status?${attachmentIdsToCheck.map((id) => `ids[]=${id}`).join('&')}`;

      // ensure all intended attachments have been processed
      $.ajax({
        type: 'GET',
        dataType: 'json',
        url: statusUrl,
        success(response) {
          if (response.data.attributes.processed) {
            submitForm();
          } else {
            $processingModal.modal('show');
            new HandshqApp.Polling({
              url: statusUrl,
              interval: 2000,
              maxTime: 120000,
              responseCheck: (r) => r.data.attributes.processed,
              successCallback: () => {
                $processingModal.modal('hide');
                submitForm();
              },
              failureCallback: handleProcessingFailure,
            }).start();
          }
        },
        error: handleProcessingFailure,
      });
    });
  }
});
